import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { collection, query, where, limit, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { logError } from '../utils/log';

const PublicProfilePage = () => {
  const { username } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    const q = query(collection(db, 'users'), where('username', '==', username), limit(1));
    const unsub = onSnapshot(q, (snap) => {
      if (snap.empty) {
        setProfile(null);
        setNotFound(true);
      } else {
        const doc = snap.docs[0];
        setProfile({ id: doc.id, ...doc.data() });
        setNotFound(false);
      }
      setLoading(false);
    }, (err) => {
      logError('Failed to fetch profile', err);
      setProfile(null);
      setNotFound(true);
      setLoading(false);
    });
    return () => unsub();
  }, [username]);

  if (loading) {
    return <div className="spinner" aria-label="Loading" />;
  }
  if (notFound) {
    return <div className="text-center text-danger">User not found</div>;
  }

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Profile: {profile?.nickname || profile?.firstName || username}</h2>
      <div className="space-y-2">
        {profile?.profileImage && <img src={profile.profileImage} alt="Profile" className="w-24 h-24 rounded-full" />}
        <p><span className="font-semibold">Email:</span> {profile?.email || 'N/A'}</p>
        <p><span className="font-semibold">Phone:</span> {profile?.phone || 'N/A'}</p>
        <p><span className="font-semibold">Username:</span> {profile?.username || username}</p>
      </div>
    </div>
  );
};

export default PublicProfilePage;
